import { put } from "redux-saga/effects";
import { GetUserMetadataResponse } from "redmond";
import fetchUserMetadata from "../../../api/v0/user/fetchUserMetadata";
import { actions } from "../actions";

export const vrAwarenessModalLocalStorageKey = "vr_awareness_modal_seen";

export function* fetchHasSeenVRAwarenessSaga(
  _: actions.IFetchHasSeenVRAwareness
) {
  try {
    const isAlreadySeen =
      localStorage.getItem(vrAwarenessModalLocalStorageKey) !== null;

    if (isAlreadySeen) {
      yield put(actions.setHasSeenVRAwareness(true));
      return;
    }
    const res: GetUserMetadataResponse = yield fetchUserMetadata({
      keys: ["hasSeenStaysVrFtux"],
    });

    const hasSeenVRAwarenessFromMetadata =
      !!res?.userMetadata?.hasSeenStaysVrFtux;

    if (hasSeenVRAwarenessFromMetadata) {
      localStorage.setItem(vrAwarenessModalLocalStorageKey, "true");
    }

    yield put(actions.setHasSeenVRAwareness(hasSeenVRAwarenessFromMetadata));
  } catch (e) {
    console.error(e);
  }
}
